import type { AxiosInstance } from 'axios'
import axios from 'axios'
import { getAccessToken } from '~/api/client/oidcClient'

export const brikkeClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BRIKKE_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  transformRequest: [(data, headers) => {
    headers.Authorization = `Bearer ${getAccessToken()}`
    return JSON.stringify(data)
  }],
})
